import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroupDirective} from '@angular/forms';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {CriteriaSearch} from 'src/app/domain/CriteriaSearch';
import {icons} from 'src/app/ui/icons';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-catalogue-p-filtre',
    templateUrl: './catalogue-p-filtre.component.html',
    styleUrls: ['./catalogue-p-filtre.component.css']
})
export class CataloguePFiltreComponent implements OnInit {
    @Output() searchoptions = new EventEmitter<Partial<any>>();
    @ViewChild(FormGroupDirective) formDirective: FormGroupDirective;


    idfils1: any;
    idfils2: any;
    idfils3: any;

    public options = {};
    form = this.formBuilder.group({
        prodId: this.formBuilder.control(null),
        prodNm: this.formBuilder.control(null),
        root: new FormControl(null),
        fils1: new FormControl({value: null, disabled: true}),
        fils2: new FormControl({value: null, disabled: true}),
        fils3: new FormControl({value: null, disabled: true}),
        cateId: new FormControl({value: null, disabled: true}),


    });
    icons = icons;

    constructor(private formBuilder: FormBuilder,
                private translate: AppTranslateService,
                private translateS: TranslateService) {
    }

    ngOnInit(): void {
    }

    getFormControl(key) {
        return this.form.get(key) as FormControl;
    }

    reset() {
        this.form.reset();
        this.formDirective.resetForm();
        this.searchoptions.emit(null);

    }

    getlangue() {

        return this.translate.getDefaultLang() == 'ar';
    }


    submit() {

        const searchvalue = [];
        if (this.form.value.prodId != null) {
            searchvalue.push(
                new CriteriaSearch(
                    'prodId',
                    this.form.value.prodId || undefined,
                    'upper_like'
                ));
        }
        if (this.form.value.prodNm != null) {
            searchvalue.push(
                new CriteriaSearch(
                    'prodNm',
                    this.form.value.prodNm || undefined,
                    'upper_like'
                ));
        }

        if (this.form.value.fils3 != null) {
            searchvalue.push(
                new CriteriaSearch(
                    'cateId',
                    this.form.value.fils3 || undefined,
                    '='
                ));
        }


        this.options = searchvalue;

        this.searchoptions.emit(this.options);
        this.options = {};
    }


    send(value) {
        if (value) {
            this.idfils1 = value.cateId;
            this.form.controls['fils1'].enable();
        } else {
            this.idfils1 = null;
            this.form.controls['fils1']?.setValue(null);
            this.form.controls['fils1']?.disable();
            this.idfils2 = null;
            this.form.controls['fils2']?.setValue(null);
            this.form.controls['fils2']?.disable();
            this.idfils3 = null;
            this.form.controls['fils3']?.setValue(null);
            this.form.controls['fils3']?.disable();
            this.form.get('cateId')?.setValue(null);
            this.form.controls['cateNm']?.setValue(null);
        }

    }

    sendfils(value: any) {
        if (value) {
            this.idfils2 = value.cateId;
            this.form.controls['fils2'].enable();
        } else {
            this.idfils2 = null;
            this.form.controls['fils2']?.setValue(null);
            this.form.controls['fils2']?.disable();
            this.idfils3 = null;
            this.form.controls['fils3']?.setValue(null);
            this.form.controls['fils3']?.disable();
            this.form.get('cateId')?.setValue(null);
            this.form.controls['cateNm']?.setValue(null);
        }

    }

    sendfils2(value: any) {
        if (value) {
            this.idfils3 = value.cateId;
            this.form.controls['fils3'].enable();
        } else {
            this.idfils3 = null;
            this.form.controls['fils3']?.setValue(null);
            this.form.controls['fils3']?.disable();
            this.form.get('cateId')?.setValue(null);
            this.form.controls['cateNm']?.setValue(null);
        }
    }

    sendfils3(value: any) {
        if (value) {
            this.form.get('cateId')?.setValue(value.cateId);
            this.form.controls['cateNm']?.setValue(value.cateNm);
        } else {
            this.form.get('cateId')?.setValue(null);
            this.form.controls['cateNm']?.setValue(null);
        }
    }
}
